export const applicationName = '千帆大模型平台';
export const PageType = '首页';
// export const ConsoleUrl = 'https://console.bce.baidu.com/aihc/resources';
// export const CustomProductUrl = 'https://cloud.baidu.com/survey/ai-heterogeneus-computing-platform.html';
